import React from 'react';
import { ACCESS_TOKEN_LOCAL_STORAGE_KEY } from 'constant';
import {
  BootstrapTooltip,
  ListItemStyled,
  ListItemTextStyled,
  NavigationLink,
  StyledOpenStack,
  StyledStack
} from 'layouts/AppLayout/components/Sidebar/components/MenuItem/styled';
import { MenuItemComponentProps } from 'layouts/AppLayout/components/Sidebar/components/MenuItem/types';


const MenuItem: React.FC<MenuItemComponentProps> = ({ MenuIcon, route, title, open, isActive }) => {
  
  // functions
  const clearCookies = () => {
    const cookies = document.cookie.split(';');
  
    cookies.forEach(cookie => {
      const cookieParts = cookie.split('=');
      const cookieName = cookieParts[0].trim();
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });
  };
  const handleLogout = async () => {
    if (title === 'Logout') {
      localStorage.clear();
      sessionStorage.clear();
      clearCookies();
      localStorage.removeItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);
      location.reload();
    }
  };

  return (
    <ListItemStyled disablePadding>
      <NavigationLink data-test={`${title}-menu-item`} to={route} onClick={handleLogout}>
        {!open && (
          <StyledStack isActive={isActive} >
            <BootstrapTooltip title={title} placement='right-start'>
              <MenuIcon />
            </BootstrapTooltip>
          </StyledStack>
        )}
        {open && (
          <StyledOpenStack direction='row' gap='16px' isActive={isActive} >
            <MenuIcon />
            <ListItemTextStyled primary={title} />
          </StyledOpenStack>
        )}
      </NavigationLink>
    </ListItemStyled>
  );
};

export default MenuItem;
